<template>
  <form
    class="trade-transfer"
    @submit.prevent="onSubmit"
  >
    <div class="columns is-multiline">
      <div class="column is-6">
        <Receiver
          is-trade-transfer
          :is-loading="loading"
          :disabled="disabled"
        />
      </div>
      <div class="column is-6">
        <VoucherDetails
          ref="voucherDetailsComponent"
          is-trade-transfer
          :is-loading="loading"
          :disabled="disabled"
        />
      </div>
      <div class="column is-12">
        <Concepts
          is-trade-transfer
          :is-loading="loading"
          :disabled="disabled"
        />
      </div>
      <div class="column is-12">
        <CfdisRelatedReplacement
          replacement-type="replacementTradeTransfer"
          :disabled="disabled"
        />
      </div>

      <div class="column is-12 action-buttons">
        <div class="field is-grouped">
          <p class="control">
            <button
              class="button is-primary"
              :class="{ 'is-loading': loading }"
              :disabled="loading || disabled"
              @click="setStamp(false)"
            >
              Guardar
            </button>
          </p>
          <p class="control">
            <button
              class="button is-success"
              :class="{ 'is-loading': loading }"
              type="submit"
              :disabled="loading || disabled"
              @click="setStamp(true)"
            >
              Guardar y Timbrar
            </button>
          </p>
          <p class="control">
            <RouterLink
              class="button is-danger"
              :class="{ 'is-loading': loading }"
              :disabled="loading"
              :to="{ name: 'Home' }"
            >
              {{ disabled ? 'Regresar' : 'Cancelar' }}
            </RouterLink>
          </p>
        </div>
      </div>
      <RouterView />
    </div>
  </form>
</template>

<script>
import get from 'lodash/get';
import { mapMutations, mapActions } from 'vuex';

export default {
  name: 'TradeTransfer',
  components: {
    Receiver: () => import(/* webpackChunkName: "invoice-receiver" */ '@/components/Admin/Invoices/NewInvoice/Receiver.vue'),
    VoucherDetails: () => import(/* webpackChunkName: "invoice-voucher-details" */ '@/components/Admin/Invoices/NewInvoice/VoucherDetails.vue'),
    Concepts: () => import(/* webpackChunkName: "trade.transfer-concepts" */ '@/components/Admin/Complements/TradeTransferConcepts.vue'),
    CfdisRelatedReplacement: () => import(/* webpackChunkName: "cfdis-related-replacement" */ '@/components/Admin/CFDI/CfdisRelatedReplacement.vue'),
  },
  data() {
    return {
      loading: false,
      disabled: false,
      stamp: false,
    };
  },
  async beforeMount() {
    this.setInitialState();

    if (this.$route.params.uuid) {
      this.loading = true;

      const cfdi = await this.$store.dispatch('invoice/getByUuid', this.$route.params.uuid);

      this.disabled = cfdi.stamped;

      this.loading = false;
    } else {
      this.$store.commit(
        'users/setValues',
        { email: '', name: '' },
      );
    }
  },
  mounted() {
    this.$store.commit(
      'invoice/setValues',
      {
        voucherType: 'T',
        voucherSeries: 'T',
      },
    );
  },
  beforeRouteUpdate(to, { name }, next) {
    if (name === 'NewInvoiceCustomerSearcher') {
      this.$refs.voucherDetailsComponent.focusEmail();
    }
    next();
  },
  methods: {
    ...mapMutations({
      setInitialState: 'invoice/setInitialState',
    }),
    ...mapActions({
      saveInvoice: 'invoice/saveTradeTransfer',
      updateInvoice: 'invoice/updateTradeTransfer',
    }),
    setStamp(value) {
      this.stamp = value;
    },
    async onSubmit() {
      this.loading = true;

      const { stamp } = this;
      const { haveEfirma, id: companyId } = this.$store.state.company;

      const { uuid } = this.$route.params;

      try {
        let payload = {};

        if (uuid) {
          payload = await this.updateInvoice({ stamp, uuid });
        } else {
          payload = await this.saveInvoice({ stamp });
        }

        const content = stamp ? 'Timbrado exitoso' : 'Guardado correctamente';
        const name = stamp ? 'InvoicesHistory' : 'PreInvoiceList';

        this.$store.commit('ui/setValue', {
          accessor: 'catalogs.sku',
          value: [],
        });

        this.loading = false;

        const to = { name };

        if (!haveEfirma && stamp) {
          this.$warning({ message: 'Necesitas cargar tu CSD para emitir la factura' });

          to.name = 'Company';
          to.params = { id: companyId };
          to.query = { stamp: get(payload, '_doc._id', '') };
        } else this.$success({ message: content });

        this.$router.push(to);
      } catch (error) {
        this.$danger({
          message: stamp
            ? error.message
            : 'Ocurrio un error al guardar.',
        });

        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.trade-transfer {
  padding: 1rem;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

@media screen and (min-width: 1088px){
  .trade-transfer:not(.concepts) {
    width: calc(100vw - 265px);
  }
}
</style>
